import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import s from './StatusTierPaywall.scss';
var StatusTierPaywall = function (_a) {
    var deviation = _a.deviation, className = _a.className, children = _a.children;
    var t = useTranslation().t;
    var _b = useSubscriptionTier(deviation), needsSubscription = _b.needsSubscription, isSubscribedButBlocked = _b.isSubscribedButBlocked;
    // TODO: this is a FE solution and only hides textContent.
    // It could be extracted (if that's something we care about)
    return needsSubscription || isSubscribedButBlocked ? (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(PromoBadge, { badgeType: "tier", size: 40, isLocked: true }),
        React.createElement("div", { className: s['subscription-needed-text'] }, needsSubscription
            ? t('deviationview.status.unsubscribedMessage')
            : t('deviationview.status.lockedMessage')))) : (React.createElement(React.Fragment, null, children));
};
StatusTierPaywall.displayName = 'StatusTierPaywall';
export default StatusTierPaywall;
//# sourceMappingURL=StatusTierPaywall.js.map